import { useEffect, useState } from "react";
import { Edit, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { adminGetFaqs, adminCreateFaq, adminUpdateFaq, adminDeleteFaq } from "./adminApi";
import { Text, Area, Modal } from "./ui";
import { Header } from "./AdminTours";

const blank = { question: "", answer: "", category: "General", order: 0 };

export default function AdminFaqs() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = () => adminGetFaqs().then(setItems).catch(() => {});
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!editing.question) { toast.error("Question required"); return; }
    setSaving(true);
    try {
      const payload = { ...editing, order: Number(editing.order) || 0 };
      if (editing.id) await adminUpdateFaq(editing.id, payload); else await adminCreateFaq(payload);
      toast.success("Saved"); setEditing(null); load();
    } catch { toast.error("Save failed"); } finally { setSaving(false); }
  };
  const del = async (f) => { if (!window.confirm("Delete this FAQ?")) return; await adminDeleteFaq(f.id); toast.success("Deleted"); load(); };
  const set = (k, v) => setEditing((e) => ({ ...e, [k]: v }));

  return (
    <div>
      <Header title="FAQs" count={items.length} onNew={() => setEditing({ ...blank })} newLabel="Add FAQ" />
      <div className="bg-white border border-[#d4af37]/25">
        {items.map((f) => (
          <div key={f.id} className="flex items-start gap-4 px-5 py-4 border-b border-[#d4af37]/15 last:border-0">
            <div className="flex-1">
              <div className="text-[10px] uppercase tracking-[0.15em] text-[#14523d]">{f.category}</div>
              <div className="font-medium text-[#3b1a1a] mt-0.5">{f.question}</div>
              <div className="text-sm text-[#5a4b4b] mt-1 clamp-2">{f.answer}</div>
            </div>
            <button onClick={() => setEditing({ ...blank, ...f })} data-testid={`edit-faq-${f.id}`} className="w-8 h-8 grid place-items-center text-[#14523d] hover:bg-[#14523d] hover:text-white"><Edit className="w-4 h-4" /></button>
            <button onClick={() => del(f)} className="w-8 h-8 grid place-items-center text-[#7c1d1d] hover:bg-[#7c1d1d] hover:text-white"><Trash2 className="w-4 h-4" /></button>
          </div>
        ))}
        {items.length === 0 && <div className="px-5 py-10 text-center text-[#5a4b4b]">No FAQs.</div>}
      </div>

      <Modal open={!!editing} onClose={() => setEditing(null)} title={editing?.id ? "Edit FAQ" : "Add FAQ"}>
        {editing && (
          <div className="space-y-4">
            <Text label="Question *" value={editing.question} onChange={(v) => set("question", v)} />
            <Area label="Answer" value={editing.answer} onChange={(v) => set("answer", v)} rows={4} />
            <div className="grid grid-cols-2 gap-4"><Text label="Category" value={editing.category} onChange={(v) => set("category", v)} /><Text label="Order" type="number" value={editing.order} onChange={(v) => set("order", v)} /></div>
            <div className="flex gap-3"><button onClick={save} disabled={saving} data-testid="save-faq" className="bg-[#7c1d1d] text-white px-8 py-3 text-xs tracking-[0.2em] uppercase disabled:opacity-60">{saving ? "Saving…" : "Save"}</button><button onClick={() => setEditing(null)} className="border border-[#d4af37]/40 px-8 py-3 text-xs tracking-[0.2em] uppercase">Cancel</button></div>
          </div>
        )}
      </Modal>
    </div>
  );
}
